<template lang="html">

  <div data="idiomas" class="cv-part">
    <h2 class="title" @click="openedit" :edit="showedit">Contacto</h2>
    <p>{{info.telefono}}</p>
    <p><template v-if="!!info.email">{{info.email}}</template></p>
    <p><template v-if="!!info.email_estudiante">{{info.email_estudiante}}</template></p>
    <p>
      <template v-if="!!info.direccion">{{info.direccion}}</template>
      <template v-if="!!info.ciudad">{{info.ciudad}}</template>
      <template v-if="!!info.paisResidencia"> {{info.paisResidencia}}</template>
    </p>
    <a v-if="!!perfildigital" :href="perfildigital | addhttps" target="_blank" rel="noopener noreferrer">Perfil digital</a>

    <div class="cover-popup row-center" :personales="canEditPersonales" v-if="showedit">
      <div class="popup row-start">
        <a class="close" @click="showedit = false">✕</a>
        <h2 class="title-pop">Editar contacto</h2>

          <div class="contenedor-inputs row-center">

        <div class="input-text">
          <label for="contactoperfildigital">Perfil Digital</label>
          <input type="url" id="contactoperfildigital" v-model="perfildigitaledit" name="perfil_digital"
            v-validate="'url'">
          <span class="error animated shake"
            v-if="errors.has('perfil_digital')">{{ errors.first('perfil_digital') }}</span>
        </div>

        <template v-if="canEditPersonales">

          <div class="input-text -middle">
            <label for="telefono">Teléfono</label>
            <input type="phone" id="telefono" v-model="personales.telefono" name="telefono" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('telefono')">{{ errors.first('telefono') }}</span>
          </div>

          <div class="input-text -middle">
            <label for="telefono">Teléfono movil</label>
            <input type="phone" id="movil" v-model="personales.movil" name="movil">
            <span class="error animated shake"
              v-if="errors.has('movil')">{{ errors.first('movil') }}</span>
          </div>

          <div class="input-text">
            <label for="telefono">Email</label>
            <input type="url" id="email" v-model="personales.email" name="email" v-validate="'email|required'">
            <span class="error animated shake" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="input-text">
            <label for="telefono">Dirección</label>
            <input type="phone" id="direccion" v-model="personales.direccion" name="direccion" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('direccion')">{{ errors.first('direccion') }}</span>
          </div>

          <div class="input-text -middle">
            <label for="telefono">Ciudad</label>
            <input type="phone" id="ciudad" v-model="personales.ciudad" name="ciudad" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('ciudad')">{{ errors.first('ciudad') }}</span>
          </div>

          <div class="input-text -middle">
            <label for="telefono">Código postal</label>
            <input type="phone" id="CP" v-model="personales.CP" name="CP" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('CP')">{{ errors.first('CP') }}</span>
          </div>

          <span></span>

          <div class="input-text -middle">
            <label for="">País de residencia</label>
            <select v-model="personales.idPaisResidencia" v-validate="'required'" name="paisresidencia"
              :error="errors.has('paisresidencia')">
              <option value="">Selecciona tu país de residencia</option>
              <option v-for="(pais,key) in paises" :value="pais[0]">{{pais[1]}}</option>
            </select>
            <span class="error animated shake"
              v-if="errors.has('paisresidencia')">{{ errors.first('paisresidencia') }}</span>
          </div>

          <div class="input-text -middle" v-if="personales.idPaisResidencia == 1">
            <label for="">Provincia</label>
            <select v-model="personales.provincia" v-validate="'required'" name="provincia"
              :error="errors.has('provincia')">
              <option value="">Selecciona tu provincia</option>
              <option v-for="(provincia,key) in provincias" :value="provincia[0]">{{provincia[1]}}</option>
            </select>
            <span class="error animated shake" v-if="errors.has('provincia')">{{ errors.first('provincia') }}</span>
          </div>

          <div class="input-text -middle" v-if="personales.idPaisResidencia != 1">
            <label for="telefono">Provincia</label>
            <input type="phone" id="provincia" v-model="personales.provincia" name="provincia" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('provincia')">{{ errors.first('provincia') }}</span>
          </div>

          <h4>¿Cómo deseas recibir las comunicaciones?</h4>

          <div class="check -radio">
            <input type="radio" id="estudiante" v-model="personales.comunicacionesEnEmailEstudiante" :value="false"
              name="comunicacionesEnEmailEstudiante">
            <label for="estudiante">En mi email de estudiante ({{info.email_estudiante}})</label>
          </div>

          <div class="check -radio">
            <input type="radio" id="personal" v-model="personales.comunicacionesEnEmailEstudiante" :value="true"
              name="comunicacionesEnEmailEstudiante">
            <label for="personal">En mi email personal ({{info.email}})</label>
          </div>

        </template>

        </div>

        <button class="btn" @click="senddata" :loading="loading">Guardar</button>
      </div>
    </div>


  </div>

</template>

<script lang="js">

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";

  Vue.use(VeeValidate);

  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'contacto',
    props: ['info', 'perfildigital'],
    mounted() {
      this.perfildigitaledit = this.perfildigital;

      for (let i in this.personales) {
        this.personales[i] = this.info[i];
      }

      if (!this.info.idProvincia) {

        let provincia = this.provincias.filter(p => {
          return (p[1].includes(this.info.provincia))
        });

        if(!!provincia){
          this.personales.provincia = provincia[0][0]
        }


      }else{
        this.personales.provincia = this.info.idProvincia;
      }

    },
    data() {
      return {
        showedit: false,
        perfildigitaledit: '',
        loading: false,
        personales: {
          telefono: '',
          email: '',
          movil: '',
          direccion: '',
          ciudad: '',
          CP: '',
          provincia: '',
          idPaisResidencia: '',
          comunicacionesEnEmailEstudiante: ''
        }
      }
    },
    methods: {
      ...mapActions(['editPerfilDigital', 'canEditCv', 'editPersonales']),
      senddata() {
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            if (this.perfildigitaledit != this.perfildigital) {
              this.editPerfilDigital(this.perfildigitaledit).then(r => {
                this.showedit = false;
              })
            }

            if (this.canEditPersonales) {
              this.loading = true;
              this.editPersonales(this.personales).then(r => {
                if(r){
                  this.loading = false;
                  this.showedit = false;
                }
              })
            }

          }
        });
      },
      openedit() {
        this.canEditCv().then(r => {
          (r) ? this.showedit = true : '';
        });
      }
    },
    computed: {
      ...mapGetters({
        canEditPersonales: 'canEditPersonales',
        dominios: 'getDominios'
      }),
      paises() {
        return Object.entries(this.dominios.paises).sort(function (p1, p2) {
          return (p1[1] < p2[1]) ? -1 : 1;
        })
      },
      provincias() {
        return Object.entries(this.dominios.provincias).sort(function (p1, p2) {
          return (p1[1] < p2[1]) ? -1 : 1;
        })
      }
    },
    filters: {
      addhttps(value){
        if(!value.includes('http')){
          value = 'https://'+value;
        }
        return value;
      }
    }

  }
</script>

<style scoped lang="scss">

  .input-text {
    margin-bottom: 15px;

    .error {
      margin-bottom: 0;
    }
  }

  h4{
    margin-bottom: 10px;
  }

  @media screen and (max-height: 900px){
    .cover-popup .popup{
      overflow: scroll;
      overflow-x: hidden;
      max-height: 90vh;
    }
  }

  @media screen and (min-width:768px) and (max-height:769px){

    .cover-popup[personales=true] .popup{
      max-width: 900px;

      .contenedor-inputs{
        width: 100%;
      }

      .input-text{
        width: 31.3%;
        margin-left: 3%;

        &:nth-of-type(3n + 1){
          margin-left: 0;
        }
      }

      span{
        display: none;
      }

      h4{
        width:100%;
        display: inline-block;
      }

    }
  
}

  

</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/contacto.vue